import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import store from '../Grade/store'

@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }

  render() {
    const { droit } = store

    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      '等级规则'
    ]

    return (
      <HeaderView title="等级规则" header={header}>
        <div className={styles.box}>
          <div className={styles.wrap}>
            <h3>等级与特权</h3>
            <table cellSpacing={0} cellPadding={0}>
              <tbody>
                <tr>
                  <td width={'20%'}>等级权限</td>
                  <td width={'16%'}>普通商家</td>
                  <td width={'16%'}>铜牌商家</td>
                  <td width={'16%'}>银牌商家</td>
                  <td width={'16%'}>金牌商家</td>
                  <td width={'16%'}>钻石商家</td>
                </tr>
                <tr>
                  <td>到店礼</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>订单礼</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>全款礼</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>优惠券</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>店铺公告</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>套餐热标</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td style={{ fontSize: 16 }}>4</td>
                  <td style={{ fontSize: 16 }}>6</td>
                  <td style={{ fontSize: 16 }}>6</td>
                </tr>
                <tr>
                  <td>荣誉特权</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>专栏展示</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>首页资源位</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>专属运营</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>分类页资源位</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>活动广告位</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>城市top10商家</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>专属活动策划</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>线下活动合作方</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
                <tr>
                  <td>媒体曝光权</td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.offimg}`} />
                  </td>
                  <td>
                    <i className={`${styles.xicon} ${styles.onimg}`} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={styles.wrap} style={{ marginTop: 20 }}>
            <h3>等级与特权</h3>
            <ul>
              {droit.map(({ id, main_title, sub_title, logo }) => (
                <li key={id}>
                  <img src={logo} />
                  <dl>
                    <dt>{main_title}</dt>
                    <dd>{sub_title}</dd>
                    {id == 1 && (
                      <a href="#/localMerchant/myShop/arrive">查看详情&gt;</a>
                    )}
                    {id == 2 && (
                      <a href="#/localMerchant/myShop/order">查看详情&gt;</a>
                    )}
                    {id == 3 && (
                      <a href="#/localMerchant/myShop/full">查看详情&gt;</a>
                    )}
                  </dl>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </HeaderView>
    )
  }
}
